// ...existing code...
import { useAuthUser } from "../auth/useAuthUser";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuthUser();
  const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (process.env.REACT_APP_AUTH_DISABLED === "true" && isLocal) {
    return children;
  }
  if (loading) return null;
  if (!user) {
    window.location.href = "/.auth/login/aad";
    return null;
  }
  return children;
}
